import axios from "axios";
import { useAuthStore } from "../stores/auth";


const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // global API URL
  // withCredentials: true, 
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const auth = useAuthStore();
  if (auth.token) {
    config.headers.Authorization = `Bearer ${auth.token}`;
  }
  return config;
});



// ✅ Response interceptor
api.interceptors.response.use(
  (response) => response, // pass through if success
  (error) => {
    if (error.response && error.response.status === 401) {
      const auth = useAuthStore();
      auth.clearAuth();

      // Optional: redirect to login page
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);
export default api;
